<template>
  <div id="bubble">
    <div class="bubble">
      <h4 v-if="called_card && called_card != 'pass'">
        Chiamo {{ nameOfCard(called_card) }}
        <span v-if="called_points != 60 && !isNaN(called_points)"> a {{ called_points}} punti</span>
      </h4>
      <h4 v-else>
        Passo
      </h4>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Bubble",
  props: {
    called_card: {
      type: String,
      required: true
    },
    called_points: {
      type: Number,
      required: true
    },
  },
  computed: {
    ...mapGetters({
      table: "tables/tableActive"
    })
},
  methods: {
    nameOfCard() {
      let map = {
        "A": "l'asso",
        "3": "il tre",
        "K": "il re",
        "Q": "la donna",
        "J": "il fante",
        "7": "il sette",
        "6": "il sei",
        "5": "il cinque",
        "4": "il quattro",
        "2": "il due",
      };
      if (this.table.card_type == 'napoletane' && this.called_card == "Q") {
        return "il cavallo";
      }
      return map[this.called_card];
    }
  }
};
</script>
<style scoped>
#bubble {
  margin-top: 1.5em;
}
.bubble {
	position: relative;
	background: whitesmoke;
	border-radius: .4em;
  font-size: 14px;
  font-weight: 600;
  padding: 10px;
}

.bubble:after {
	content: '';
	position: absolute;
	top: 0;
	left: 50%;
	width: 0;
	height: 0;
	border: 1em solid transparent;
	border-bottom-color: whitesmoke;
	border-top: 0;
	margin-left: -1em;
	margin-top: -1em;
}
</style>
